import { cn, ClassValue } from "@/libs/utils/tailwind/cn";

export default function PeopleIcon({ className }: Props) {
  return (
    <svg
      className={cn("size-10 text-primary", className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M26.6663 35V31.6667C26.6663 29.8986 25.964 28.2029 24.7137 26.9526C23.4635 25.7024 21.7678 25 19.9997 25H9.99967C8.23156 25 6.53587 25.7024 5.28563 26.9526C4.03539 28.2029 3.33301 29.8986 3.33301 31.6667V35M26.6663 5.21322C28.0959 5.58383 29.362 6.41866 30.2658 7.58665C31.1696 8.75465 31.66 10.1897 31.66 11.6665C31.66 13.1434 31.1696 14.5784 30.2658 15.7464C29.362 16.9144 28.0959 17.7493 26.6663 18.1199M36.6663 34.9998V31.6665C36.6652 30.1893 36.1736 28.7544 35.2686 27.587C34.3636 26.4196 33.0966 25.5858 31.6663 25.2165M21.6663 11.6667C21.6663 15.3486 18.6816 18.3333 14.9997 18.3333C11.3178 18.3333 8.33301 15.3486 8.33301 11.6667C8.33301 7.98477 11.3178 5 14.9997 5C18.6816 5 21.6663 7.98477 21.6663 11.6667Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface Props {
  className?: ClassValue;
}
